<template>
  <div class="_main">
    <div class="_top">
      <el-form :model="contractForm" :rules="rules" ref="ruleForm" inline>
        <el-form-item label="合同名称：">
          <el-input
            v-model="contractForm.contractName"
            placeholder="请输入合同名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司抬头：">
          <el-input
            v-model="contractForm.acceptCompany"
            placeholder="请输入公司抬头"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同签订年份：">
          <el-select v-model="contractForm.contractDate" placeholder="请选择">
            <el-option
              v-for="item in yearsData"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchBtn()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="addContract()"
            >+ 新增合同</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" size="medium" @click="importContract()"
            >导入合同</el-button
          >
        </el-form-item>
        <input
          type="file"
          ref="importInput"
          accept=".xlsx, .xls"
          @change="handleFileImport"
          style="display: none"
        />
      </el-form>
    </div>
    <div class="_table">
      <el-table
        :data="groupData"
        border
        v-loading="pageLoading"
        class="hetongTable"
        height="100%"
      >
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>

        <!--        <el-table-column prop="acceptCompany" label="承包单位" width="110">-->
        <!--        </el-table-column>-->
        <el-table-column prop="contractNo" label="合同编号" width="180">
        </el-table-column>
        <el-table-column prop="contractName" label="合同名称" min-width="15%">
        </el-table-column>
        <el-table-column
          prop="customTime"
          label="合同日期"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              formatDate(scope.row.startDate) +
              "-" +
              formatDate(scope.row.endDate)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sendCompany" label="发包单位" min-width="13%">
        </el-table-column>
        <el-table-column prop="manager" label="负责人" width="80">
        </el-table-column>
        <el-table-column prop="amount" label="合同总额" width="100">
          <template slot-scope="scope">
            <span>{{
              "￥" +
              scope.row.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="关联项目" min-width="8%">
          <template slot-scope="scope">
            <span v-if="!isEmpty(scope.row.projectName)">{{
              scope.row.projectName
            }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="状态" width="70">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status == 1 ? 'info' : 'success'"
              class="change-state"
              @click=""
            >
              {{ scope.row.status == 1 ? "作废" : "正常" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="showDetails(scope.row)"
              >查看</el-button
            >

            <el-button type="text" size="medium" @click="editFunc(scope.row)"
              >编辑</el-button
            >
            <!-- <el-button
              v-if="adminInfo"
              type="text"
              size="medium"
              @click="delContract(scope.row)"
              >删除</el-button
            > -->

            <el-button
              v-if="adminInfo"
              type="text"
              size="medium"
              @click="cancelFunc(scope.row)"
              v-show="scope.row.status === 0"
              >删除</el-button
            >

            <el-button
              type="text"
              size="medium"
              @click="exportContract(scope.row)"
              >导出表格</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span style="font-size: 18px; font-weight: 700">确定删除此份合同？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ensureClick()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ContractServer from "../../api/pServer/contract";
import TaskDispatchApi from "@/api/taskDispatch";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      adminInfo: null,
      rules: {},
      contractForm: {
        acceptCompany: "",
        contractDate: "",
        contractName: "",
        pageDto: {
          current: 1,
          size: 1000,
        },
        status: "",
      },
      yearsData: [],
      groupData: [],
      pageLoading: false,
      dialogVisible: false,
      deleteId: "",
    };
  },
  created() {
    for (let i = 2000; i <= 2025; i++) {
      this.yearsData.push({
        id: i,
        value: i + "年",
      });
    }
    this.searchBtn();
    this.getUserInfoName();
  },
  methods: {
    //身份校验
    getUserInfoName() {
      TaskDispatchApi.getUserInfo().then((res) => {
        if (res.data.code === 200) {
          this.adminInfo = res.data.data.sysAdmin;
        }
        console.log("-->>", this.adminInfo);
      });
    },
    isEmpty(str) {
      return !str || str.trim() === "";
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}.${month}.${day}`;
    },
    searchBtn() {
      this.pageLoading = true;
      ContractServer.queryContractInfo(this.contractForm).then((res) => {
        this.pageLoading = false;
        if (res.data.code == 200) {
          this.groupData = res.data.data.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    addContract() {
      this.$router.push({ name: "addContract", query: { pageId: "0" } });
    },
    contractTips(data) {
      this.$router.push({ name: "contractTips", query: { info: data } });
    },
    editFunc(data) {
      this.$router.push({
        name: "editContract",
        query: { contractInfo: JSON.stringify(data), pageId: "1" },
      });
    },
    cancelFunc(data) {
      this.dialogVisible = true;
      this.deleteId = data.id;
    },
    ensureClick() {
      TaskDispatchApi.contractDelete({ id: this.deleteId }).then((res) => {
        this.dialogVisible = false;
        this.searchBtn();
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    showDetails(data) {
      //显示相信信息
      this.$router.push({
        name: "contractDetails",
        query: { contractInfo: JSON.stringify(data), pageId: "1" },
      });
    },
    // 导出合同数据为Excel
    exportContract(data) {
      // 暂时注释掉API请求，直接导出空模板
      // // 获取合同详情
      // ContractServer.getContractById({ id: data.id }).then((res) => {
      // if (res.data.code === 200) {
      const contract = res.data.data;
      // 准备导出数据
      const exportData = {
        "发包单位：": contract.sendCompany || "",
        "合同编号：": contract.contractNo || "",
        "承包单位：": contract.acceptCompany || "",
        "合同名称：": contract.contractName || "",
        "合同总额：": contract.amount || 0,
        "合同开始日期：": contract.startDate
          ? this.formatDate(contract.startDate)
          : "",
        "合同结束日期：": contract.endDate
          ? this.formatDate(contract.endDate)
          : "",
        "责任人：": contract.manager || "",
        "付款条款：": contract.payCondition || "",
        "合同说明：": contract.description || "",
        "附件URL：": contract.attachment || "",
        "附件名称：": contract.attachmentName || "",
      };

      // 创建工作簿
      const wb = XLSX.utils.book_new();
      // 将数据转换为工作表
      const ws = XLSX.utils.json_to_sheet([exportData], {
        header: Object.keys(exportData),
      });
      // 设置列宽
      ws["!cols"] = [
        { wch: 20 }, // 发包单位
        { wch: 20 }, // 合同编号
        { wch: 20 }, // 承包单位
        { wch: 30 }, // 合同名称
        { wch: 15 }, // 合同总额
        { wch: 15 }, // 合同开始日期
        { wch: 15 }, // 合同结束日期
        { wch: 15 }, // 责任人
        { wch: 40 }, // 付款条款
        { wch: 30 }, // 合同说明
        { wch: 50 }, // 附件URL
        { wch: 30 }, // 附件名称
      ];
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, "合同详情");
      // 导出Excel文件
      XLSX.writeFile(
        wb,
        `${contract.contractName || "合同"}_${
          contract.contractNo || "编号"
        }.xlsx`
      );
      this.$message.success("导出成功");
      // } else {
      //   this.$message.error(res.data.message || '获取合同详情失败');
      // }
      // }).catch(err => {
      //   console.error('导出合同失败:', err);
      //   this.$message.error('导出合同失败');
      // });

      // 直接导出空模板
      this.exportTemplate();
    },
    // 导入合同
    importContract() {
      // 导出带表头的空模板
      this.exportTemplate();
      this.$refs.importInput.click();
    },
    // 导出空模板
    exportTemplate() {
      // 准备表头数据
      const headers = [
        "发包单位：",
        "合同编号：",
        "承包单位：",
        "合同名称：",
        "合同总额：",
        "合同开始日期：",
        "合同结束日期：",
        "责任人：",
        "付款条款：",
        "合同说明：",
        "附件URL：",
        "附件名称：",
      ];

      // 创建空数据行
      const emptyData = headers.map(() => "");

      // 创建工作簿
      const wb = XLSX.utils.book_new();
      // 创建工作表数据（表头+空数据）
      const wsData = [headers, emptyData];
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // 设置列宽
      ws["!cols"] = [
        { wch: 20 }, // 发包单位
        { wch: 20 }, // 合同编号
        { wch: 20 }, // 承包单位
        { wch: 30 }, // 合同名称
        { wch: 15 }, // 合同总额
        { wch: 15 }, // 合同开始日期
        { wch: 15 }, // 合同结束日期
        { wch: 15 }, // 责任人
        { wch: 40 }, // 付款条款
        { wch: 30 }, // 合同说明
        { wch: 50 }, // 附件URL
        { wch: 30 }, // 附件名称
      ];

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, "合同导入模板");
      // 导出Excel文件
      XLSX.writeFile(wb, "合同导入模板.xlsx");
      this.$message.success("模板导出成功");
    },
    // 处理文件导入
    handleFileImport(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          // 获取第一个工作表
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          // 将工作表转换为JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          if (jsonData.length < 2) {
            this.$message.error("导入的文件内容为空或格式不正确");
            return;
          }

          // 解析数据
          const headers = jsonData[0];
          const values = jsonData[1];

          // 构建合同对象
          const contractData = {};
          headers.forEach((header, index) => {
            const value = values[index] || "";
            switch (header) {
              case "发包单位：":
                contractData.sendCompany = value;
                break;
              case "合同编号：":
                contractData.contractNo = value;
                break;
              case "承包单位：":
                contractData.acceptCompany = value;
                break;
              case "合同名称：":
                contractData.contractName = value;
                break;
              case "合同总额：":
                contractData.amount = Number(value) || 0;
                break;
              case "合同开始日期：":
                contractData.startDate = this.parseDate(value);
                break;
              case "合同结束日期：":
                contractData.endDate = this.parseDate(value);
                break;
              case "责任人：":
                contractData.manager = value;
                break;
              case "付款条款：":
                contractData.payCondition = value;
                break;
              case "合同说明：":
                contractData.description = value;
                break;
              case "附件URL：":
                contractData.attachment = value;
                break;
              case "附件名称：":
                contractData.attachmentName = value;
                break;
            }
          });

          // 跳转到新增页面，并传递数据
          this.$router.push({
            name: "addContract",
            query: {
              pageId: "0",
              importData: JSON.stringify(contractData),
            },
          });
          this.$message.success("导入成功，请确认信息后保存");
        } catch (error) {
          console.error("导入文件解析失败:", error);
          this.$message.error("导入文件解析失败，请检查文件格式");
        }
      };
      reader.readAsArrayBuffer(file);
      // 清空input，以便下次选择同一文件也能触发change事件
      event.target.value = "";
    },
    // 解析日期字符串为时间戳
    parseDate(dateStr) {
      if (!dateStr) return null;
      try {
        const date = new Date(dateStr.replace(/\./g, "/"));
        if (isNaN(date.getTime())) {
          return null;
        }
        return date.getTime();
      } catch (error) {
        console.error("日期解析失败:", error);
        return null;
      }
    },
  },
};
</script>

<style scope>
._main {
  width: calc(100%);
  height: 100%;
  background-color: #fff;
}

._top {
  width: 100%;
  height: auto;
  border-radius: 4px;
  /* padding-left: 20px; */
  padding-top: 10px;
}

.el-form-item {
  margin-left: 30px;
}

._table {
  padding: 0 20px;
  width: 100%;
  height: calc(100% - 60px);
  overflow-y: auto;
}

.custom-button {
  border: none;
}

.button-image {
  height: 30px;
  width: 30px;
}
</style>

<style>
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  text-align: left;
}
</style>
